import { IAttrValue } from "@multiweb/types/contracts";
import { EMPTY_ITEM_RIGHTS_COLLECTION } from "Global/Base/Rights/RightTypes";
import { AttrValueReader } from "../../../../../../../OW.Remoting/Remoting/AttrValueReader";
import { Enum } from "../../../../../../../OW.Remoting/Remoting/DataTypes/Enums";
import { IValidatable } from "../../../../../../UI.BaseControls/ControlInterfaces";
import { Column } from "../../../../../../UI.Controls/DataGridSubcontrols/Columns/Column";
import { ICellContent } from "../../../../../../UI.Controls/DataGridSubcontrols/Components/ICellContent";
import { EditItemTemplate } from "../../../../../../UI.Controls/DataGridSubcontrols/Templates/EditItemTemplate";
import { ElementUtils } from "../../../../../../UI.ElementarControls/Helpers/ElementUtils";
import { ComboBox } from "../../../../Controls/ComboBox";
import { IHTMLElementWithControl } from "../../../../Controls/ControlInterfaces";
import { EnumColumn } from "../EnumColumn";

export class EnumEditTemplate extends EditItemTemplate {
    private _initPromise: Promise<void> = Promise.resolve(); // Promise, cekajici na inicializaci dat

    public override render(column: Column, dataSet: IAttrValue[]): ICellContent {
        const data = this._getDataFromSet(dataSet);

        // jelikoz neexistuje EnumAttribute, tak se musi enumName nacist z prvni hodnoty co prijde
        if (!(column as EnumColumn).enumName && data instanceof Enum) {
            (column as EnumColumn).enumName = (data as Enum).getTypeName();
        }

        return super.render(column, [data]);
    }

    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        const control = (item as IHTMLElementWithControl).tscControl as ComboBox;
        // combobox obsahuje enum, ktery se docita asynchrone a pri prvnim pouziti by tu jeste nemusel byt pred vlozenim dat a proto je treba na nej pockat
        // bylo to zdrojem potencionalnich problemu viz. 22917
        await this._initPromise;
        control.controlValue = AttrValueReader.read(this._getDataFromSet(dataSet));
    }

    protected override _createEditElement(column: Column, dataSet: IAttrValue[], parentItem: HTMLElement): { element: HTMLElement; validatableControl: IValidatable } {
        const editableControl = document.createElement("div");
        editableControl.setAttribute("data-enumName", (column as EnumColumn).enumName);
        editableControl.setAttribute("data-attrName", column.attrName);
        const combo = new ComboBox({ element: editableControl, originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION });
        combo.enabledVisual = false; //předejde se tak možnosti editovat hodnotu dříve než to povolí práva

        this._initPromise = combo.initialize();
        combo.dataType = column.dataType;
        combo.attrName = column.attrName;
        combo.controlValue = AttrValueReader.read(this._getDataFromSet(dataSet));
        combo.isEditing = true;
        combo.valueChanged.add(() => {
            ElementUtils.callEvent(parentItem, "valuechanged", { value: combo.controlValue, column: column });
        });
        return { element: combo.element, validatableControl: combo };
    }
}
